<aside
  class="kga-sidebar h-full rounded-[28px] shadow-2xl transition-all duration-500 ease-in-out will-change-[width] z-20"
  [class.collapsed]="isCollapsed" [style.width]="isCollapsed ? '80px' : '195px'">

  <div class="pt-3 flex"
  [ngClass]="isCollapsed ? 'justify-center' : 'justify-end pr-3'">
    <button (click)="toggleSidebar()"
      class="kga-sidebar-toggle-btn absolute p-2 text-white bg-white/10 border border-white/20 hover:bg-white/20 !rounded-lg transition-all duration-300 z-50 shadow-sm">
      <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none"
        stroke="currentColor" stroke-width="2" class="w-4 h-4">
        <path d="M4 5h16"></path>
        <path d="M4 12h16"></path>
        <path d="M4 19h16"></path>
      </svg>
    </button>
  </div>

  <div class="pt-[60px] md:pt-[58px] px-[9px] transition-all duration-500">
    <nav class="space-y-[7px] overflow-auto thin-scrollbar max-h-[calc(100vh-220px)] pr-[8px]">

      @for (menu of visibleMenus; track menu.tooltip) {
      <div>
        <div (click)="toggleMenu(menu)" [routerLink]="!menu.children && !menu.externalUrl ? menu.route : null"
          routerLinkActive="active-menu" [routerLinkActiveOptions]="{ exact: true }"
          [title]="isCollapsed ? menu.tooltip : ''"
          [ngClass]="isMenuActive(menu) ? 'active-menu-item opacity-100 translate-x-1' : ''"
          class="sidebar-menu-item flex items-center justify-between cursor-pointer transition-all duration-300 p-2.5 rounded-full group relative opacity-80 hover:opacity-100 hover:translate-x-1">
          <div class="flex items-center gap-[10px]">
            <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none"
              stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"
              class="w-[14px] h-[14px] flex-shrink-0 text-white">
              <path *ngFor="let path of menu.icon.paths" [attr.d]="path"></path>
            </svg>
            <span *ngIf="!isCollapsed" class="text-white text-[11px] font-semibold whitespace-nowrap">
              {{ menu.tooltip }}
            </span>
          </div>

          @if (menu.children && !isCollapsed) {
          <svg xmlns="http://www.w3.org/2000/svg"
            class="w-[13px] h-[13px] text-white/70 flex-shrink-0 transition-transform duration-300"
            [class.rotate-0]="activeMenu === menu.tooltip" [class.-rotate-90]="activeMenu !== menu.tooltip"
            viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2">
            <path d="m6 9 6 6 6-6"></path>
          </svg>
          }
        </div>

        @if (menu.children && activeMenu === menu.tooltip && !isCollapsed) {
        <div class="ml-[20px] mt-2 space-y-2 max-h-[180px] overflow-y-auto overflow-x-hidden thin-scrollbar pr-1">
          @for (child of menu.children; track child.tooltip) {
          <div [routerLink]="child.route" routerLinkActive="active-submenu" [routerLinkActiveOptions]="{ exact: true }"
            [title]="isCollapsed ? child.tooltip : ''"
            [ngClass]="isChildActive(child) ? 'active-submenu-item translate-x-1 shadow-sm' : ''" class="sidebar-submenu-item cursor-pointer px-2.5 py-1.5 flex items-start gap-2 rounded-xl border-l-2
          transition hover:translate-x-1 whitespace-normal break-words">
            <div class="w-1.5 h-1.5 rounded-full flex-shrink-0 mt-1"></div>
            <span class="block">{{ child.tooltip }}</span>
          </div>
          }
        </div>
        }
      </div>
      }

    </nav>
  </div>

  <!-- <div class="absolute bottom-[10px] left-1/2 -translate-x-1/2 transition-all duration-500">
    <img src="/_assets/v11/04c22697a6016b133945ca08264a7bd455ce15a3.png" alt="Canarys"
      class="w-[140px] h-[42px] opacity-90 hover:opacity-100 transition-all duration-500 drop-shadow-[0_4px_12px_rgba(95,168,50,0.25)] hover:drop-shadow-[0_6px_16px_rgba(95,168,50,0.35)] hover:scale-105" />
  </div> -->
</aside>